// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_qc-0";